export default __webpack_public_path__ + "d5fba944fb354571e5f435b77daae635.png";